import { render, staticRenderFns } from "./arrow-down-new-ux.vue?vue&type=template&id=7705c037&"
import script from "./arrow-down-new-ux.vue?vue&type=script&lang=js&"
export * from "./arrow-down-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7705c037')) {
      api.createRecord('7705c037', component.options)
    } else {
      api.reload('7705c037', component.options)
    }
    module.hot.accept("./arrow-down-new-ux.vue?vue&type=template&id=7705c037&", function () {
      api.rerender('7705c037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/arrow-down-new-ux.vue"
export default component.exports